import { render } from "./CompanyInactive.vue?vue&type=template&id=2768f79d"
import script from "./CompanyInactive.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyInactive.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Company/CompanyInactive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2768f79d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2768f79d', __exports__)) {
    api.reload('2768f79d', __exports__)
  }
  
  module.hot.accept("./CompanyInactive.vue?vue&type=template&id=2768f79d", () => {
    api.rerender('2768f79d', render)
  })

}


export default __exports__